import { render } from "./SideMenu.vue?vue&type=template&id=cc852c3e"
import script from "./SideMenu.vue?vue&type=script&lang=js"
export * from "./SideMenu.vue?vue&type=script&lang=js"
script.render = render

export default script